import {
  CircularProgress,
  Button,
  Typography,
  TextField,
  Chip,
} from "@mui/material";
import { async } from "q";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import {
  setModalOpen,
  updateVerificationData,
  sendVerificationOTP,
  verifyOTP,
  selectVerificationModal,
  selectVerificationData,
  selectVerificationLoading,
  fetchVerificationOptions,
} from "../../../Store/Gmb/gmbVerificationSlice";
import { selectVerificationOptions } from "../../../Store/Gmb/gmbVerificationSlice";
import {  isLoading, setEditing } from "../../../Store/Gmb/gmbStoreSlice";



export default function StoreVerification({
  accountId,
  locationId,
  isStoreVerified,
}) {
  const dispatch = useDispatch();
  const dialogRef = useRef(null);

  const verificationOptions = useSelector(selectVerificationOptions);
  const { isOpen, otpSent, isVerifying } = useSelector(selectVerificationModal);
  const { phoneNumber, otpType, otpCode, verificationId } = useSelector(
    selectVerificationData,
  );
  const loading = useSelector(selectVerificationLoading);
  const storeCode = useSelector(
    (state) => state.gmbStore.storeDetail.store_code,
  );
  const primaryPhoneNumber = useSelector(
    (state) => state.gmbStore.storeDetail.primary_phone,
  );

  const isOtpValid = otpCode.length === 6;
  const isOnlyAddressVerificationOption =
    verificationOptions?.length === 1 &&
    verificationOptions[0].verificationMethod.toLowerCase() === "address";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        dispatch(setModalOpen(false));
        return;
      }
    };

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, dispatch]);

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 6) {
      dispatch(updateVerificationData({ otpCode: value }));
    }
  };

  const handleSendOtp = () => {
    dispatch(
      sendVerificationOTP({
        account_id: accountId,
        location_id: locationId,
        method: otpType,
        phoneNumber,
      }),
    );
  };

  const handleSubmitOtp = () => {
    if (!verificationId) return;

    dispatch(
      verifyOTP({
        account_id: accountId,
        location_id: locationId,
        verification_id: verificationId,
        pin: otpCode,
        storeCode: storeCode,
      }),
    )
     dispatch(setEditing(false))
  };

  const handleClose = () => {
    dispatch(setModalOpen(false));
  };

  const handleApplyForVerification = async () => {
    if(!primaryPhoneNumber){
      toast.error("Please add Primary Phone Number to verify store");
      return;
    }
    dispatch(fetchVerificationOptions(locationId)).then((action) => {
      const newVerificationOptions = action.payload;
      const isOnlyAddressVerificationOption =
        newVerificationOptions?.length === 1 &&
        newVerificationOptions[0].verificationMethod.toLowerCase() ===
          "address";
    
    const verificationEmpytArray = newVerificationOptions?.length === 0;
      if (verificationEmpytArray || isOnlyAddressVerificationOption) {
        toast.warn("Please contact Admin to verify store");
        return;
      }
     else {
        dispatch(setModalOpen(true));
        return;
      }
    });
  };

  useEffect(() => {
    if (verificationOptions?.length > 0) {
      dispatch(
        updateVerificationData({
          otpType: verificationOptions[0].verificationMethod,
          phoneNumber: verificationOptions[0].phoneNumber,
        }),
      );
    }
  }, [verificationOptions, dispatch]);

  return (
    <div className="relative flex">
      {/* comment the apply for verification button  */}
      <div className="flex flex-col justify-center items-center">

        {!isStoreVerified && (
          <Button
            onClick={handleApplyForVerification}
            className="bg-blue-500 text-white px-4 py-2 rounded-2xl flex items-center capitalize shadow-[0_4px_8px_3px_rgba(0,0,0,0.15)] hover:text-blue-500"
          >
            {loading.fetchOptions ? (
              <CircularProgress  sx={{
                m:"4px"
              }} size="18px" color="inherit" />
            ) : (
              <>Apply for Verification</>
            )}
          </Button>
        )}
      </div>

      {isOpen && !isOnlyAddressVerificationOption && (
        <div className="fixed inset-0 bg-black flex items-center justify-center z-[9999] bg-opacity-50 backdrop-filter backdrop-blur-sm ">
          <div
            ref={dialogRef}
            className="bg-white rounded-lg p-6 w-full max-w-md"
          >
            <div className="flex items-center justify-between border-b ">
              <Typography variant="h3" className="text-xl font-semibold">
                Google My Business Verification
              </Typography>
              <Button
                onClick={handleClose}
                className="text-gray-400 hover:bg-gray-200 py-2 px-4 mb-1 rounded-lg"
              >
                &times;
              </Button>

              
            </div>

            <div className="space-y-4 mt-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Typography>Phone</Typography>
                </label>
                <TextField
                  value={phoneNumber}
                  disabled
                  className="w-full"
                  sx={{
                    input:{cursor: "not-allowed"},
                    "& .MuiOutlinedInput-input": {
                      padding: "8px",
                    },
                  }}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Typography>Type</Typography>
                </label>
                <select
                  value={otpType}
                  onChange={(e) => {
                    const selectedType = e.target.value;
                    const selectedOption = verificationOptions?.find(
                      (option) => option.verificationMethod === selectedType,
                    );
                    dispatch(
                      updateVerificationData({
                        otpType: selectedType,
                        phoneNumber: selectedOption?.phoneNumber || "",
                      }),
                    );
                  }}
                  className="w-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                >
                  {verificationOptions?.map((option) => (
                    <option
                      key={option?.verificationMethod}
                      value={option?.verificationMethod}
                      className="rounded-lg border-2 border-green-400 capitalize"
                    >
                      {option?.verificationMethod?.replace("_", " ")}
                    </option>
                  ))}
                </select>
              </div>

              {otpSent && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <Typography>OTP</Typography>
                  </label>
                  <TextField
                    type="tel"
                    value={otpCode}
                    onChange={handleOtpChange}
                    className="w-full"
                    placeholder="Enter OTP"
                    sx={{
                      "& .MuiOutlinedInput-input": {
                        padding: "8px",
                      },
                    }}
                  />
                </div>
              )}
            </div>

            <div className="mt-6 flex justify-end">
              {!otpSent ? (
                <Button
                onClick={handleSendOtp}
                disabled={loading.sendOTP}
                className={`px-4 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-opacity-50 ${
                  loading.sendOTP
                    ? "bg-gray-500 text-white"
                    : "bg-blue-500 text-white"
                } hover:${
                  loading.sendOTP ? "bg-gray-500" : "bg-blue-600"
                } focus:ring-blue-500 capitalize`}
              >
                {loading.sendOTP ? (
                  <div className="flex flex-row justify-center items-center gap-2">
                    <Typography className="text-white">Sending OTP</Typography>
                    <CircularProgress size="16px" className="text-white" />
                  </div>
                ) : (
                  <Typography>Send OTP</Typography>
                )}
              </Button>
              ) : (
                <Button
                  onClick={handleSubmitOtp}
                  disabled={!isOtpValid || loading.verifyOTP}
                  className={`px-4 py-2 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-opacity-50
                    ${
                      isOtpValid && !loading.verifyOTP
                        ? "bg-green-500 hover:bg-green-600 focus:ring-green-500"
                        : "bg-gray-400 cursor-not-allowed"
                    }`}
                >
                  {loading.verifyOTP ? (
                    <div className="flex flex-row justify-center items-center gap-2 capitalize">
                      <Typography>Verifying OTP</Typography>
                      <CircularProgress size="16px" color="inherit" />
                    </div>
                  ) : (
                    <Typography>Verify OTP</Typography>
                  )}
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
